
import React from 'react';

const leafIconUrl = "data:image/svg+xml;base64," + btoa(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path fill="#059669" d="M12,2C17.5,2 22,6.5 22,12C22,17.5 17.5,22 12,22C6.5,22 2,17.5 2,12C2,6.5 6.5,2 12,2M12,4C7.58,4 4,7.58 4,12C4,16.42 7.58,20 12,20C16.42,20 20,16.42 20,12C20,7.58 16.42,4 12,4M12,6C15.31,6 18,8.69 18,12C18,15.31 15.31,18 12,18C8.69,18 6,15.31 6,12C6,8.69 8.69,6 12,6Z"/>
  </svg>
`);

export const TypingIndicator = () => (
  <div className="flex space-x-2 items-center">
    <div className="w-2 h-2 bg-emerald-500 rounded-full animate-[nature-typing_1.5s_infinite_ease-in-out]"></div>
    <div className="w-2 h-2 bg-emerald-500 rounded-full animate-[nature-typing_1.5s_infinite_ease-in-out]" style={{animationDelay: '0.2s'}}></div>
    <div className="w-2 h-2 bg-emerald-500 rounded-full animate-[nature-typing_1.5s_infinite_ease-in-out]" style={{animationDelay: '0.4s'}}></div>
  </div>
);

export const BackgroundEffects = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10">
    {/* Animated gradient background */}
    <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/30 via-green-100/20 to-emerald-50/10 animate-nature-morph -z-10"></div>
    
    {/* Floating leaves */}
    <div className="nature-leaves -z-10">
      {[...Array(12)].map((_, i) => (
        <div 
          key={i}
          className="nature-leaf"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 15}s`,
            transform: `rotate(${Math.random() * 360}deg) scale(${0.6 + Math.random() * 0.4})`,
            zIndex: '-1'
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="leaf-svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" 
                  fill="currentColor" 
                  className="text-emerald-400/40" />
          </svg>
        </div>
      ))}
    </div>

    {/* Gentle breeze effect */}
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-emerald-100/5 to-transparent animate-nature-breeze -z-10"></div>

    {/* Nature particles (pollen/seeds) */}
    <div className="nature-particles -z-10">
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          className="nature-particle"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${2 + Math.random() * 3}px`,
            height: `${2 + Math.random() * 3}px`,
            animationDelay: `${Math.random() * 10}s`,
            zIndex: '-1'
          }}
        ></div>
      ))}
    </div>

    {/* Light rays */}
    <div className="nature-rays -z-10">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="nature-ray"
          style={{
            left: `${20 + i * 30}%`,
            animationDelay: `${i * 2}s`,
            zIndex: '-1'
          }}
        ></div>
      ))}
    </div>
  </div>
); 